import React from "react";
import TableBookingB2B from "../../componentes/Tabla/TableBookingB2B";

export default function ReservasB2B() {
  return (
    <TableBookingB2B />
  )
}